import { EventTypes } from '../../../types/event.types';
import type { EventHandlerMap } from '../../../libs/events/eventHandler';

export const reviewRecordsEventHandlers: EventHandlerMap = {
    [EventTypes.CitationsDocumentDeleted]: (event, queryClient) => {
        queryClient.invalidateQueries({ queryKey: ['reviews', 'records', event.scopeId] });
    },
    [EventTypes.CitationsDocumentImportCompleted]: (event, queryClient) => {
        queryClient.invalidateQueries({ queryKey: ['reviews', 'records', event.scopeId] });
    },
};
